define('Responsive/util/array',['require','exports','module'],function(require,exports,module){
	var oToString=Object.prototype.toString,
		ARTYPE=oToString.call([]),
		Arslice=Array.prototype.slice,
		isArray=Array.isArray || function( obj ) {
			return (obj instanceof Array) && oToString.call(obj)===ARTYPE;
		},
		UNDEF;
			// check if object is an array
	return {
		ensureArray : function (obj, len){
			obj = obj && (isArray(obj) ? obj : [obj]) || [];
			if(len){
				obj[len]=obj[len]||UNDEF;
			}
	        return obj;
	    },
		map : function(arr, callback){
			return arr.map(callback);
		},
		isArray: isArray,

	    slice : function(ar,l){
	    	return Arslice.call(ar,l||0);
	    },

	    toArray : function(ar,l){
	    	return this.slice(ar,l);
	    }
	};
});
